import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el sistema?',
  a: 'Inmediatamente después de completar tu compra recibirás un correo con el enlace de descarga. En menos de dos minutos tendrás acceso a los 6 Tomos, los 5 Bonos y todos los recursos incluidos.'
}, {
  q: '¿Es un curso?',
  a: 'No. Es un sistema digital compuesto por guías, herramientas, árboles de decisión, planificadores y recursos prácticos diseñados para ayudarte a decidir qué tejer rápidamente.'
}, {
  q: '¿Sirve para crochet y dos agujas?',
  a: 'Sí. El sistema fue diseñado para funcionar con crochet, dos agujas y tejido tradicional. Las rutas de decisión se adaptan a cualquiera de estas técnicas.'
}, {
  q: '¿Necesito experiencia?',
  a: 'No. Encontrarás rutas para principiantes, nivel intermedio y avanzado. El sistema te guía según tu experiencia.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí. No existen mensualidades. No hay renovaciones automáticas. Compras una sola vez y el acceso es tuyo para siempre.'
}, {
  q: '¿Puedo imprimir el material?',
  a: 'Sí. Todos los tomos y plantillas fueron diseñados para utilizarse tanto en formato digital como impreso.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream-2 px-4 py-14" data-id="element-82" data-mp="6r6jdu2md33w">
      <div className="mx-auto max-w-2xl" data-id="element-83" data-mp="6plpm6o4po73">
        <h2 className="text-center font-display text-2xl font-black text-plum-deep sm:text-4xl" data-id="element-84" data-mp="biessq3y8oh2">
          Preguntas Frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-85" data-mp="3t0hjtutjttbi">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-mauve-soft/40" data-id="element-86" data-mp="3jy8cfdtkug2c" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-87" data-mp="3nysb4ltstrql">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-88" data-mp="1krt9edxam8ga">
                    {f.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 flex-none text-mauve transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-89" data-mp="1fpvicxini9cs" />
                </button>
                <AnimatePresence initial={false} data-id="element-90" data-mp="23gzto5dqj847">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-91" data-mp="1zfxshj09clzl">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-plum/75" data-id="element-92" data-mp="o3548i6oefoa">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}